import _ from "lodash";
import { useSelector } from "react-redux";
import store from "store";
import useCurrentService from "./useCurrentService";
import { PREFERENCES_KEYS } from "../modules/app/middlewares/userPreferencesMiddleware";

const HISTORY_SIZE = 4;

export const SERVICE_HISTORY_KEY = "services_history";

/*
 * This hook adds the accessed services to a history book for record-keeping.
 * The history is stored in local storage and maintains a maximum size.
 */
export default function useServicesAccessHistory() {
    const navItems = useSelector(state => state.menu.navItems);
    const currentService = useCurrentService();
    const servicesByTo = useSelector(state => state.menu.servicesByTo);

    if (_.isEmpty(navItems) || _.isEmpty(servicesByTo) || !currentService?.service?.to) {
        return
    }
    const currServCategory = servicesByTo[currentService.service.to]?.category;
    const category = _.find(navItems, category => category.label === currServCategory);

    if (category) {
        addToServicesHistory({ serviceKey: currentService.newKey });
    } else if (currentService?.newKey !== "NetApp.Home") {
        addToServicesHistory({ serviceKey: "Platform.Canvas" });
    }
}

export function addToServicesHistory({ serviceKey }) {
    const state = store.getState()?.userPreferences;
    const appPreferences = _.get(state, PREFERENCES_KEYS.APP_PREFERENCES)?.data || {};
    const servicesHistory = appPreferences[SERVICE_HISTORY_KEY] || [];
    const indexOfItem = servicesHistory.findIndex(item => item === serviceKey);
    if (indexOfItem === 0) {
        return; // If the service is already at the top, no need to add it again
    }
    if (indexOfItem !== -1) {
        // If the service already exists, remove it to add it again at the beginning
        servicesHistory.splice(indexOfItem, 1);
    }
    //add the service to the beginning of the history to ensure the most recent is first
    servicesHistory.unshift(serviceKey);
    if (servicesHistory.length > HISTORY_SIZE) {
        // If the history exceeds, remove the oldest one
        servicesHistory.pop();
    }

    appPreferences[SERVICE_HISTORY_KEY] = servicesHistory;
    //push to store
    store.dispatch({
        type: "PREFERENCES:SAVE_OR_UPDATE",
        payload: { name: PREFERENCES_KEYS.APP_PREFERENCES, data: appPreferences }
    });
}
